/**
 * Converts an image URL to a base64 data URL to avoid CORS issues in PDF generation.
 * @param {string} url - The image URL to convert.
 * @returns {Promise<string|null>} The base64 data URL or null if conversion fails.
 */
export const convertImageToDataUrl = async (url) => {
	if (!url) return null;
	try {
		const response = await fetch(url, { mode: 'cors' });
		if (!response.ok) return null;
		const blob = await response.blob();
		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.onerror = () => resolve(null);
			reader.readAsDataURL(blob);
		});
	} catch (error) {
		console.error('Failed to convert image to data URL:', error);
		return null;
	}
};

